module.exports = __webpack_public_path__ + "img/mobile_caret_right.82e15.png";